/** Standard 16×16 glyph slot for every canvas toolbar button icon. */
export const canvasToolbarIconClassName = "size-4 shrink-0";
